<template>
    <div class="border rounded p-1">
    <bubble-menu :editor="editor" :tippy-options="{ duration: 100 }" v-if="editor">
      <button @click="editor.chain().focus().toggleBold().run()" :class="[{ 'active': editor.isActive('bold') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-bold" />
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="[{ 'active': editor.isActive('italic') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-italic" />
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="[{ 'active': editor.isActive('strike') },'btn', 'btn-light',' btn-sm']">
        <i class="fa fa-strikethrough" />
      </button>
    </bubble-menu>
    <editor-content :editor="editor" class="p-2" />
  </div>
</template>

<script>
import StarterKit from '@tiptap/starter-kit'
import { BubbleMenu,Editor, EditorContent } from '@tiptap/vue-2'

export default {
  components: {
    EditorContent,
    BubbleMenu,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      editor: null,
    }
  },

  watch: {
    value(value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    },
  },

  mounted() {
    this.editor = new Editor({
      content: this.value,
      extensions: [
        StarterKit,
      ],
      onUpdate: () => {
        // HTML
        this.$emit('input', this.editor.getHTML())

        // JSON
        // this.$emit('input', this.editor.getJSON())
      },
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
/* Basic editor styles */
.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }
}
</style>
<style >

.ProseMirror:focus {
    outline: none;
  }

</style>